/* One controller per section, with editor lifecycle and explicit playback control. */
(() => {
  if (window.GrowplayBanner) return;
  const controllers = new Map();
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  function init(scope = document) {
    scope.querySelectorAll('[data-growplay-pro-banner]').forEach(banner => {
      if (controllers.has(banner)) return;
      const slides = [...banner.querySelectorAll('[data-banner-slide]')];
      const dots = [...banner.querySelectorAll('[data-banner-dot]')];
      const playback = banner.querySelector('[data-banner-playback]');
      let index = 0, timer, paused = motion.matches, hovered = false, focused = false, visible = true;
      const show = next => {
        index = (next + slides.length) % slides.length;
        slides.forEach((slide, i) => { slide.classList.toggle('is-active', i === index); slide.inert = i !== index; });
        dots.forEach((dot, i) => { dot.classList.toggle('is-active', i === index); dot.setAttribute('aria-pressed', String(i === index)); });
      };
      const sync = () => {
        clearInterval(timer);
        if (playback) {
          playback.textContent = paused ? '▶' : 'Ⅱ';
          playback.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow');
        }
        if (slides.length > 1 && banner.dataset.autoplay === 'true' && !paused && !hovered && !focused && visible && !document.hidden) {
          timer = setInterval(() => show(index + 1), Number(banner.dataset.interval) || 5000);
        }
      };
      dots.forEach(dot => dot.addEventListener('click', () => {show(Number(dot.dataset.bannerDot)); sync();}));
      playback?.addEventListener('click', () => {paused = !paused; sync();});
      banner.addEventListener('mouseenter', () => { hovered = banner.dataset.pauseOnHover === 'true'; sync(); });
      banner.addEventListener('mouseleave', () => { hovered = false; sync(); });
      banner.addEventListener('focusin', () => { focused = true; sync(); });
      banner.addEventListener('focusout', e => { focused = banner.contains(e.relatedTarget); sync(); });
      const changed = () => {paused = motion.matches; sync();};
      motion.addEventListener('change', changed);
      document.addEventListener('visibilitychange', sync);
      const observer = new IntersectionObserver(entries => {visible = entries[0].isIntersecting; sync();});
      observer.observe(banner);
      show(0); sync();
      controllers.set(banner, () => {clearInterval(timer); observer.disconnect(); motion.removeEventListener('change', changed); document.removeEventListener('visibilitychange', sync);});
    });
  }
  document.addEventListener('shopify:section:load', e => init(e.target));
  document.addEventListener('shopify:section:unload', e => controllers.forEach((cleanup,banner) => {if (e.target.contains(banner)) {cleanup(); controllers.delete(banner);}}));
  window.GrowplayBanner = {init};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once:true});
  else init();
})();
